import apiClient from '../index';

export const notificationApi = {
  // Notifications
  getGuestsForNotifications: (data) => apiClient.post('/guests/notifications', data),
  sendNotifications: (data) => apiClient.post('/guests/send-notifications', data),
  getNotifications: () => apiClient.get('/guests/notification-index'),
};

export default notificationApi;
